module.exports = __webpack_public_path__ + "img/footer_qjwx.d634b3e1.png";